import {RiskReportView} from "../risk";

export class OpportunitiesReportView extends RiskReportView{
    is_opportunity=true;

}